import { Line } from 'src/types/search';

export default function transformSearchResultSourceLines(
  lines: Line[]
): string {
  return lines
    .map(l => l.segments.reduce((text, segment) => text + segment.text, ''))
    .join('\n');
}
